<script setup>
import { subs_time, formattedDate, get_meta } from '@/helper';
import { retrieve_children } from '@/services/child';
import { onMounted, ref } from 'vue';

const props = defineProps({
  subscribePackage: {
    type: Object,
    required: true
  }
})

const isLoading = ref(true)
onMounted(async ()=>{
  await get_children()
  // console.log("🚀 ~ onMounted ~ children.value:", children.value)
  isLoading.value = false
})

const children = ref([])
async function get_children(){
  let response = await retrieve_children('?subscription=true')
  if (response.error){
    swalError(response.result, true)
    return
  }
  
  if (response.result.data.status.empty){
    children.value = []  
    return
  }
  children.value = parseChildMeta(response.result.data.children)
}

const hasShow = ref(false)
function parseChildMeta(result){
  let tempChildren = result.data
  let included = result.included.filter(item => item.type == 'child_subscription')
  included.forEach(inc => {
    let child = tempChildren.find(c => parseInt(c.id) === inc.attributes.child_id)
    if (child) {
      if (!child.hasOwnProperty('subscriptions')){
        child.subscriptions = []
      }
      if (inc.attributes.subscription_id == props.subscribePackage.id){
        child.show = true
        hasShow.value = true
        child.subscriptions.push({
          id: inc.attributes.subscription_id,
          start_date: inc.attributes.start_date,
          created_at: inc.attributes.created_at
        })
      }
    }
  });
  return tempChildren
}

function getDuration(child){
  let subscription = child.subscriptions.find(subs => subs.id == props.subscribePackage.id)
  let time_left = 0
  if (subscription){
    if (!subscription.start_date){
      time_left = get_meta(props.subscribePackage.meta, 'duration') + ' days'
    }else{
      time_left = subs_time(subscription.start_date, get_meta(props.subscribePackage.meta, 'duration'))
    }
  }else{
    time_left = 'Error'
  }
  return time_left || 'Expired'
}

</script>

<template>
  <loadingCard v-if="isLoading" />
  <div v-else class="">
    <h6>Subscribed Child</h6>
    <template v-if="hasShow">
      <template v-for="child in children">
        <div v-if="child.show"  class="card border shadow-none mb-2">
          <div class="card-body px-3 py-2">
            <p class="mb-0">
              {{ child.attributes.name }}
            </p>
            <p>
              <b>Time Left : </b>
              {{ getDuration(child) }}
            </p>
            <!-- <p>
              <b>Subscribed Date : </b>
              {{ formattedDate(child.subscriptions[0].created_date) }}
            </p> -->
            <!-- <p>
              <b>Start Date : </b>
              {{ formattedDate(child.subscriptions[0].start_date) }}
            </p> -->
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="mb-4">
        <p>No child has subscribe to this package</p>
      </div>
    </template>
  </div>
</template>